import { createClient, LDContext } from '@launchdarkly/js-client-sdk'

// Hack for typescript to allow us to assign these properties to window
// https://stackoverflow.com/a/56458070/5004115
declare global {
  interface Window {
    featureFlags: any
    launchdarklySettings: unknown
  }
}

function isSettings(settings: unknown): settings is LDContext {
  return typeof settings === 'object' && settings !== null && 'kind' in settings
}

export async function initializeLaunchDarkly() {
  if (import.meta.env.NODE_ENV !== 'test') {
    // Copy the feature flags into a separate object,
    // so we can use it as the bootstrap and a default
    // value for the client.variation calls.
    const bootstrap = { ...window.featureFlags }

    const LDClientKey = import.meta.env?.VITE_LAUNCH_DARKLY_CLIENT_KEY || ''
    const context = isSettings(window.launchdarklySettings)
      ? window.launchdarklySettings
      : ({
          anonymous: true,
          // https://launchdarkly.com/docs/home/flags/context-kinds#about-context-kinds
          kind: 'user'
        } satisfies LDContext)

    const client = createClient(LDClientKey, context)
    client.setStreaming(true)
    client.on('change', (_ctx, changes: string[]) => {
      changes.forEach(key => {
        window.featureFlags[key] = client.variation(key, bootstrap[key])
      })
    })

    client.start({ bootstrap })
    await client.waitForInitialization({ timeout: 20 })
  }
}

export default function hasFeature(key: string, defaultValue = false) {
  if (window.featureFlags && window.featureFlags[key]) {
    return window.featureFlags[key]
  }
  return defaultValue
}
